// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__1y2ry","content":"styles_content__1bDcO","intro":"styles_intro__2Lrn8"};